import React, { useEffect, useState } from "react";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CircularProgress } from "@mui/material";
import { jwtDecode } from "jwt-decode";
import { toast } from "react-toastify";
import PaginationComponet from "src/Components/GlobalComponents/PaginationComponet";
import SplashScreen from "src/Components/SplashScreen";
import RangeSlider from "src/Components/WebsiteComponents/RangeSlider";
import DiagnosticBanner from "src/assets/images/Diagnostic-banner-img.png";
import { getToken, truncateString } from "src/helpers/helperFunctions";
import httpRequest from "src/helpers/httpRequest";
import { IqueryParams } from "src/types/GlobalInterfaces";
import { IPaginated } from "src/types/paginated";
import qs from "qs";
import { Link } from "react-router-dom";
import IsFavoriteComponent from "src/Components/Customer/ProductsAndServicesComponents/IsFavoriteComponent";
import AddCartComponent from "src/Components/Customer/ProductsAndServicesComponents/AddCartComponent";
import testInclude from "src/assets/images/test-include.png";
import { CURRENCY } from "src/lib/constans";
interface ICategory {
  _id: string;
  name: string;
  image: string;
}

interface IPackageObj {
  _id: string;
  name: string;
  image: string;
  prescriptionRequired: boolean;
  regularPrice: number;
  salePrice: number;
  isLiked: boolean;
  noOfTests: number;
}

const DiagnosticPackagesWeb: React.FC = () => {
  const token = getToken() || "";
  let decoded: { id: string };
  if (token) {
    decoded = jwtDecode<{ id: string }>(token);
  } else {
    decoded = { id: "" };
  }
  const [dropdown, setDropDown] = useState<{
    category: boolean;
    price: boolean;
  }>({
    category: true,
    price: true,
  });
  const toogleDropDown = (key: "category" | "price") => {
    setDropDown((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [allPackages, setAllPackages] = useState<IPackageObj[]>([]);
  const [paginated, setPaginated] = useState<IPaginated>({
    currentPage: 1,
    totalPages: 1,
  }); // Handles pagination state
  const [queryParams, setQueryParams] = useState<IqueryParams>({
    page: 1,
    limit: 20,
    userId: decoded.id || "",
    categoryIds: "",
    minPrice: 0,
    maxPrice: 10000,
  });
  const handleChangeCategory = (id: string) => {
    setQueryParams((prev) => {
      const prevArr = prev?.categoryIds?.split(",")?.filter(Boolean) || [];
      return {
        ...prev,
        page: 1,
        categoryIds: prevArr?.includes(id)
          ? prevArr?.filter((v: string) => v !== id)?.join(",")
          : [...prevArr, id]?.join(","),
      };
    });
  };
  const handlePriceChange = (val: number[]) => {
    setQueryParams((prev) => {
      return {
        ...prev,
        page: 1,
        minPrice: val[0],
        maxPrice: val[1],
      };
    });
  };
  const handleIsLikeChanged = (obj: {
    productId: string;
    isLiked: boolean;
  }) => {
    const { productId = "", isLiked = false } = obj;
    setAllPackages((prev) =>
      prev?.map((v) => (v._id === productId ? { ...v, isLiked } : v))
    );
  };
  const fetch = async () => {
    setIsLoader(true);
    const { res, err } = await httpRequest<{
      documents: IPackageObj[];
      paginated: IPaginated;
    }>({
      path: `/product/all-diagnostic-packages?${qs.stringify(queryParams)}`,
    });
    if (res) {
      let { documents = [], paginated = { currentPage: 1, totalPages: 1 } } =
        res;
      setAllPackages(documents);
      setPaginated(paginated);
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };
  useEffect(() => {
    fetch();
  }, [queryParams]);

  const [categoryLoader, setCategoryLoader] = useState<boolean>(false);
  const [allCategories, setAllCategories] = useState<ICategory[]>([]);
  const fetchCategories = async () => {
    setCategoryLoader(true);
    const { res, err } = await httpRequest<{ result: ICategory[] }>({
      path: "/diagnostic-product/categories/all",
    });
    if (res) {
      setAllCategories(res?.result || []);
    } else {
      toast(err, { type: "error" });
    }
    setCategoryLoader(false);
  };
  useEffect(() => {
    fetchCategories();
  }, []);
  const categoryChangeFilter = (id: string) => {
    setQueryParams((prev) => {
      return {
        ...prev,
        page: 1,
        // ids: [id],
        categoryIds: id,
      };
    });
  };
  return (
    <>
      {isLoader && <SplashScreen />}
      <div className="pharmacy-banner">
        <div className="container-1400">
          <div className="py-4">
            <img
              className="thumbnail-img-by-category"
              src={DiagnosticBanner}
              alt="Diagnostic Products"
            />
          </div>
          <div>
            <h2 className="font-size-28px font-Poppins-SemiBold theme-color-green">
              Top Categories
            </h2>
            <div className="top-categories-main">
              {allCategories?.slice(0, 6)?.map((item) => (
                <div
                  key={item?._id}
                  onClick={() => categoryChangeFilter(item?._id)}
                  className="flex gap-2 flex-col items-center"
                >
                  <div className="top-categories-img">
                    <img src={`${item?.image}`} alt="banner-dummy-pic" />
                  </div>
                  <span className="font-size-18px font-Poppins-SemiBold theme-color-green">
                    {item?.name || ""}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white py-4">
        <div className="container-1400">
          <div className="product-by-categories-main-grid">
            <div className="product-by-categories-left">
              <div
                className={`${
                  dropdown.category
                    ? ""
                    : "product-by-categories-head-inner-open"
                } product-by-categories-head-inner`}
              >
                <span className="font-Poppins-Medium text-white font-size-18px">
                  Categories ({allCategories?.length || 0})
                </span>
                <FontAwesomeIcon
                  className="font-size-18px cursor-pointer text-white"
                  icon={dropdown.category ? faChevronUp : faChevronDown}
                  onClick={() => toogleDropDown("category")}
                />
              </div>
              {dropdown.category ? (
                <div className="product-by-categories-padd">
                  <div className="pt-3">
                    {categoryLoader && (
                      <div className="text-center">
                        <CircularProgress
                          size={16}
                          className="theme-color-green"
                        />
                      </div>
                    )}
                    {allCategories?.map((v) => (
                      <div
                        key={v?._id}
                        className="flex gap-3 items-center product-by-categories-checkbox"
                      >
                        <input
                          checked={queryParams?.categoryIds
                            ?.split(",")
                            ?.includes(v?._id)}
                          type="checkbox"
                          id={v?._id}
                          onChange={() => handleChangeCategory(v?._id)}
                        />
                        <label
                          className="font-Poppins-Medium text-[#707070] font-size-16px"
                          htmlFor={v?._id}
                        >
                          {v?.name}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              ) : null}
              <div>
                <div
                  className={`${
                    dropdown.price
                      ? ""
                      : "product-by-categories-head-inner-open"
                  } product-by-categories-head-inner`}
                >
                  <span className="font-Poppins-Medium text-white font-size-18px">
                    Price
                  </span>
                  <FontAwesomeIcon
                    className="font-size-18px cursor-pointer text-white"
                    icon={dropdown.price ? faChevronUp : faChevronDown}
                    onClick={() => toogleDropDown("price")}
                  />
                </div>
                {dropdown.price && (
                  <div className="p-6">
                    <div>
                      <RangeSlider
                        minRange={0}
                        maxRange={10000}
                        step={100}
                        currentRanges={[
                          queryParams?.minPrice,
                          queryParams?.maxPrice,
                        ]}
                        changePriceRanges={handlePriceChange}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="product-by-categories-right">
              <span className="font-Poppins-Medium text-white product-by-categories-head-result font-size-18px">
                Results For Diagnostics
              </span>
              <div className="result-for-health-care">
                {allPackages.map((item) => (
                  <div key={item?._id} className="daiganostic-product-card">
                    <Link to={`/diagnostic-product/package/${item?._id}/view`}>
                      <img
                        className="diagnostic-product-inner-img"
                        src={`${item?.image}`}
                        alt={""}
                      />
                    </Link>
                    <div className="Prescription-requird-main">
                      <div className="Prescription-requird">
                        {item?.prescriptionRequired ? (
                          <span className="Prescription-requird-inner-span text-white font-Poppins-Regular font-size-12px">
                            Prescription Required
                          </span>
                        ) : (
                          <span></span>
                        )}
                        <IsFavoriteComponent
                          productId={item?._id}
                          isFav={item?.isLiked || false}
                          category="package"
                          onSuccess={handleIsLikeChanged}
                        />
                      </div>
                    </div>
                    <div className="daiganostic-product-card-content">
                      <Link
                        to={`/diagnostic-product/package/${item?._id}/view`}
                      >
                        <p className="theme-color-green mb-2 pharmacy-card-main-span-title font-Poppins-SemiBold font-size-14px">
                          {truncateString(item?.name, 40)}
                        </p>
                      </Link>
                      <div className="product-card-test-include-main">
                        <div className="product-card-test-include">
                          <img src={testInclude} alt="" />
                          <span className="text[#333333] font-size-12px font-Poppins-Regular">
                            {item?.noOfTests || ""} Tests
                          </span>
                        </div>
                      </div>
                      <div className="daiganostic-product-card-content-price">
                        {/* <span className='theme-color-green font-Poppins-Bold font-size-18px'>{`${CURRENCY} ${item?.regularPrice || "-"}`}</span> */}
                        <div className="sale-price-or-regular-price">
                          <strong className="font-size-18px font-Poppins-Bold theme-color-green">
                            {CURRENCY} {item?.salePrice || item?.regularPrice}
                          </strong>
                          {item?.salePrice != null && item?.salePrice > 0 && (
                            <strong className="font-size-13px line-through font-Poppins-Regular text-[#878787]">
                              {CURRENCY} {`${item?.regularPrice || "-"}`}
                            </strong>
                          )}
                        </div>
                        <AddCartComponent
                          productId={item?._id}
                          type="diagnostic"
                          prescriptionRequired={
                            item?.prescriptionRequired || false
                          }
                          quantity={1}
                          itemType="package"
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="pagination-padding-web">
                <PaginationComponet
                  currentPage={paginated.currentPage || 1}
                  total={paginated.totalPages || 1}
                  setCurrentPage={(_page) =>
                    setQueryParams((prev) => ({ ...prev, page: _page }))
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DiagnosticPackagesWeb;
